export default "__VITE_ASSET__4f209477__"